module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "main"
  })]), _vm._v(" "), _c('div', {
    staticClass: "custom-legend"
  }, [_c('div', [_c('i', [_vm._v("1")]), _vm._v("广州 35252\n      ")]), _vm._v(" "), _c('div', [_c('i', [_vm._v("2")]), _vm._v("北京 32674\n      ")]), _vm._v(" "), _c('div', [_c('i', [_vm._v("3")]), _vm._v("上海 32234\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f6f9996!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/flow/index.vue
// module id = 1955
// module chunks = 2